import React from 'react';
import { PROVIDERS_MAP } from 'common/constants/constants';
import { useParams } from 'react-router';
import styled from 'styled-components';
import copy from 'copy-to-clipboard';

import { Flex, IconLinkWrapper } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import QueryString from 'query-string';

const Logo = styled.img`
  height: 100%;
  width: 4rem;
  padding-left: 1rem;
`;

const ChallengeCallback = () => {
  const { providerName = '' } = useParams();
  const provider = providerName && PROVIDERS_MAP[providerName];
  const codeValue = QueryString.parse(window.location.search)['code'];

  return (
    <Flex
      justify='center'
      margin='auto'
      borderRadius='0.5em'
      backgroundColor='white'
      height='15em'
      width='80em'
    >
      <Flex items='center' grow='10' direction='column' justify='space-around'>
        {provider && provider.logo ? (
          <>
            <Flex direction='column'>
              <Logo src={provider.logo} alt='' />
              <Text size='large'>{provider.name} Auth</Text>
            </Flex>
          </>
        ) : (
          <Text size='large' pt='0.2rem' color='shuttleGray'>
            Provider: {providerName}
          </Text>
        )}
        {!!codeValue ? (
          <>
            <Flex direction='column' content='center'>
              <Flex self='center'>
                <Text size='medium' pt='0.2rem' color='shuttleGray'>
                  Please copy the code below and continue with the authorization
                  process as described in the on-prem agent README
                </Text>
              </Flex>
              <Flex
                self='center'
                margin='1em'
                justify='space-evenly'
                width='70%'
              >
                <Flex>
                  <Text size='large'>{codeValue}</Text>
                </Flex>
                <Flex>
                  <IconLinkWrapper
                    ml='negative-nomral'
                    onClick={() => copy(codeValue)}
                  >
                    <Icon name='Clipboard' />
                  </IconLinkWrapper>
                </Flex>
              </Flex>
            </Flex>
          </>
        ) : (
          <Text size='medium' pt='0.2rem' color='shuttleGray'>
            Wrong query params (hint: "code" is missing)
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export default ChallengeCallback;
